export const DESKTOP_MIN_WIDTH = 1440
export const DESKTOP_MIN_HEIGHT = 900
export const TABLET_MIN_WIDTH = 1024
export const MOBILE_MIN_WIDTH = 576

export const ARIA_LIVE_HTML_ID = 'aria-live-region'
